// Units an outbreak can be scoped to: the facility's live, real units. EditOutbreak builds its
// Unit options from this, and anything that pre-selects units for it (the infection case creator
// after an outbreak alert) must use the same filter so every selected unit has an option.
const PLACEHOLDER_UNIT_CODE = "PLACE_HOLDER";

export const selectableUnits = (facility) =>
  ((facility && facility.units) || []).filter((unit) => unit.code !== PLACEHOLDER_UNIT_CODE && unit.archived !== true);
